import React, { useCallback } from 'react'
import { MainLayout } from '../../../../../../shared/components/main-layout/main-layout.component'
import { ConsumerEmailView } from './components/consumer-email-view/consumer-email-view.component'
import { ConsumerEmailStepProps } from './consumer-email-step.props'

export const ConsumerEmailStep = (props: ConsumerEmailStepProps) => {
  const onComplete = () => props.onComplete(props.step)

  const goBack = useCallback(() => {
    props.goBack(props.step)
  }, [props.step, props.goBack])

  return (
    <MainLayout goBack={props.goBack} step={props.step} hideFooter>
      <ConsumerEmailView
        onComplete={onComplete}
        goBack={goBack}
        step={props.step}
      />
    </MainLayout>
  )
}
